import { useEffect, useState } from 'react';
import { apiGet } from '../../markets/api/apiClient';

export interface MonitorLink {
    indicator: string;
    bank: string;
    bankName: string;
    meetingDate: string;
    decisionTs: number | null;
    label: string | null;
}

interface WireLinks {
    links?: Array<{
        indicator: string;
        bank: string;
        bank_name: string;
        meeting_date: string;
        decision_ts: number | null;
        label: string | null;
    }>;
}

const NONE: MonitorLink[] = [];
const cache = new Map<string, Promise<MonitorLink[]>>();

function load(eventId: string, slug: string | null): Promise<MonitorLink[]> {
    const key = `${eventId}|${slug ?? ''}`;
    const hit = cache.get(key);
    if (hit) return hit;
    const params = new URLSearchParams({ event_id: eventId });
    if (slug) params.set('slug', slug);
    const value = apiGet<WireLinks>(`/api/monitor/links?${params.toString()}`)
        .then(res =>
            (res.links ?? []).map(l => ({
                indicator: l.indicator,
                bank: l.bank,
                bankName: l.bank_name,
                meetingDate: l.meeting_date,
                decisionTs: l.decision_ts,
                label: l.label,
            }))
        )
        .catch(() => NONE);
    cache.set(key, value);
    return value;
}

export function useMonitorLinks(
    eventId: string | null,
    slug: string | null
): MonitorLink[] {
    const [links, setLinks] = useState<MonitorLink[]>(NONE);
    useEffect(() => {
        if (!eventId) {
            setLinks(NONE);
            return;
        }
        let cancelled = false;
        load(eventId, slug).then(next => {
            if (!cancelled) setLinks(next);
        });
        return () => {
            cancelled = true;
        };
    }, [eventId, slug]);
    return links;
}
